/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @angular-eslint/no-input-rename */
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LayoutBounds } from '@utils/widgets/layout';


@Component({
  template: '',
})
export abstract class DataInterfaceComponent<TData, TSettings, TLayout = LayoutBounds> implements OnInit, OnChanges {
  @Input() public data: TData | undefined;
  @Input() public settings: TSettings | undefined;
  @Input() public layout: TLayout | undefined;

  @Input('settings-window-member') public set settingsByWindowMember(member: string) {
    this.settings = (window as any)[member] as TSettings;
  }
  @Input('data-window-member') public set dataByWindowMember(member: string) {
    this.data = (window as any)[member] as TData;
  }
  @Input('layout-window-member') public set layoutByWindowMember(member: string) {
    this.layout = (window as any)[member] as TLayout;
  }

  public ngOnInit(): void {
    // calling dataUpdate() here is not needed for web apps or Storybook as ngOnChanges() is triggered on component
    // initialization but it is necessary for web components to be rendered correctly in BO.
    this.dataUpdate();
  }

  public ngOnChanges({ data, changes, settings }: SimpleChanges): void {
    if (!data && !settings && !changes) {
      return;
    }

    this.dataUpdate();
  }

  protected dataUpdate(): void {
    return;
  }
}
